import styled, { css } from "styled-components";

export const Filters = styled.div`

`;

export const FilterButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: transparent;
	padding-left: 20px;
	padding-right: 20px;
	border-radius: 5px;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 360px;
	margin-top: 20px;
	padding: 30px;
	gap: 5px;
	flex-shrink: 0;
	border: 1px solid var(--Gray-40, #e1e1e7);
	border-radius: 10px;
	background: var(--Blue-10, #f3f6f9);
	box-shadow: 0px 25px 44px 0px rgba(12, 9, 45, 0.03);
	.filter-button {
		display: flex;
		justify-content: flex-end;
		background-color: transparent;
		border: 0;
		margin-bottom: 1rem;
	}
`;

export const FilterWrapperButtons = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	font-size: 14px;
	font-weight: 500;
	line-height: 32px;
	margin-top: 20px;
	gap: 15px;
`;
export const FilterGoFilterButton = styled.button`
	width: 78px;
	height: 44px;
	padding: 8px 20px;
	border-radius: 5px;
	${(props) =>
		props.isDisable
			? css`
					background-color: var(--Gray-20, #f0f0f3) !important;
					color: var(--Gray-100, #b5b5c3);
			  `
			: css`
					background-color: rgba(37, 85, 239, 1) !important;
					color: var(--White, var(--White-100, #fff));

					&:hover {
						background-color: #214dd7 !important;
					}
			  `}
`;
export const FilterClearButton = styled.button`
	width: 78px;
	height: 44px;
	padding: 8px 20px;
	border-radius: 5px;
	margin-right: 16px;
	background-color: ${(props) =>
		props.isDisable ? "var(--Gray-10, #F8F8F9) !important" : " rgba(37, 85, 239, 0.08) !important"};

	${(props) =>
		props.isDisable
			? css`
					background-color: var(--Gray-10, #f8f8f9) !important;
					color: var(--Gray-100, #b5b5c3);
			  `
			: css`
					background-color: rgba(37, 85, 239, 0.08) !important;
					color: #2555ef;
					&:hover {
						background: rgba(37, 85, 239, 0.2) !important;
					}
			  `}
`;

export const CloseButtonWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: right;
	z-index: 0;
`;

export const FilterCloseButton = styled.button`
	z-index: 9999;
`;

export const FilterRows = styled.div``;

export const FilterColumn = styled.div`
	margin-bottom: 20px;
`;
